// extracted by mini-css-extract-plugin
module.exports = {"container":"CardUsuario_container__3bi7b","subtitulo":"CardUsuario_subtitulo__2xjTF","titulo":"CardUsuario_titulo__38TCz"};